import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "environments/environment";
import { GS1NotificationLevel, GS1NotificationService } from "@gs1france/gs1-components-library";
import { lastValueFrom } from "rxjs";
import { CompanyModule } from "../company.module";
import { AllSEPAMandates } from "../models/Mandate.model";
let __URL_API__  = `${environment.URL_API}`; 

@Injectable({providedIn: 'root'})
export class MandatService {
    constructor(private http: HttpClient, private notifications: GS1NotificationService, private translate: TranslateService) {}

    async createMandate(IBAN: string, PhoneNumber: string, Email: string) {
        try {
            const body: any =  {IBAN, PhoneNumber, Email}
            body.RedirectUrlOK = `${environment.URL_Front}entreprise/moyens-de-paiement/SSPOK`;
            body.RedirectUrlNOK = `${environment.URL_Front}entreprise/moyens-de-paiement/SSPNOK`;
            const SSPUrl = await lastValueFrom(this.http.post<string>(__URL_API__ + 'api/Mandate/CreateMandate', body));
            window.location.href = SSPUrl;
        } catch (err) {
            this.handleError(err, 'Company.SEPA.form.error-get-mandat');
        }
    }

    async getMandates(): Promise<AllSEPAMandates> {
        try {
            const previousMandates: AllSEPAMandates = await lastValueFrom(this.http.get<AllSEPAMandates>(__URL_API__+'api/Mandate/GetMandates'))
            return previousMandates;
        } catch (err) {
            this.handleError(err, 'GlobalErrors.default');
        }
    }

    async updateMandate(BIC:string,IBAN:string): Promise<AllSEPAMandates> {
        try {
const allMandates: AllSEPAMandates = await lastValueFrom(
      this.http.patch<AllSEPAMandates>(
        __URL_API__ + 'api/Mandate/UpdateMandate',
        { IBAN, BIC } 
      )
    );
            this.handleSuccess('Company.SEPA.modify.notif-success');
            return allMandates;
        } catch (err) {
            this.handleError(err, 'Company.SEPA.modify.notif-error')
        }
    }

    async revocMandate(): Promise<AllSEPAMandates> {
        try {
            const allMandates : AllSEPAMandates = await lastValueFrom(this.http.post<AllSEPAMandates>(__URL_API__+'api/Mandate/RevoqueMandate', null));
            this.handleSuccess('Company.SEPA.Revoq.notif-success');
            return allMandates;
        } catch (err) {
            this.handleError(err, 'Company.SEPA.Revoq.notif-error')
        }
    }

    handleError(err: any, message?: string) {
        this.notifications.addNotification(this.translate.instant(message), 'error');
        throw err;
    }

    
    handleSuccess(message: string, level: GS1NotificationLevel = 'success') {
        this.notifications.addNotification(this.translate.instant(message), level);
    }
}